import { render, staticRenderFns } from "./ListBonCharge.vue?vue&type=template&id=8a94dfc4&scoped=true&"
import script from "./ListBonCharge.vue?vue&type=script&lang=js&"
export * from "./ListBonCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a94dfc4",
  null
  
)

export default component.exports